module.exports = __webpack_public_path__ + "img/service1.eb300005.png";